import axios from "axios";
import store from '@/store';

const http = axios.create();

function ifTimedOut() {
  console.log("ifTimedOut");
  setTimeout(() => {
    // Assuming you have access to Vue instance or store and router directly

    store.dispatch('auth/logout');
    window.location.href = "/login";
  }, 2000);
  alert("Sesjonen er utløpt. Logg inn på nytt.");
}

/* Response Interceptors */
const interceptResErrors = (error) => {
  if (error.response && error.response.data) {
    console.log(error.response.data.message);
  }
  console.log("interceptResErrors", error);
  if (error.response && error.response.status == 440) {
    console.log("Got response 440");
    ifTimedOut();
  }
  if (error.response && error.response.status == 500) {
    console.log("Got response 500");
    alert("Feil har oppstått. Dersom problemet vedvarer kan systemet være nede.");
  }
  error = Object.assign(new Error(), {message: error.message});
  return Promise.reject(error);
};
const interceptResponse = (res) => {
  // console.log("interceptResponse", res);
  try {
    if ( res.response.status == 440 ) {
      console.log("Got response 440 - Not error - Not possible?...");
      ifTimedOut();
    }
    return Promise.resolve(res.data);
  } catch (e) {
    return Promise.resolve(res);
  }
};
http.interceptors.response.use(interceptResponse, interceptResErrors);

/* Request Interceptors */
const interceptReqErrors = err => Promise.reject(err);
const interceptRequest = (config) => {
  return config;
};
http.interceptors.request.use(interceptRequest, interceptReqErrors);

http.publicPath = "/api";
http.headers = {
  "Content-type": "application/json"
};

export default http;